export enum UserAuthStatus {
    PENDING = 'PENDING',
    USER_AUTHORIZED = 'USER_AUTHORIZED',
    USER_NOT_AUTHORIZED = 'USER_NOT_AUTHORIZED',
}
